(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  const placeholders = Array.from(document.querySelectorAll('.lazy-section-placeholder'));
  if (!placeholders.length) return;

  const loadingIds = new Set();

  async function loadSection(placeholder) {
    if (!placeholder || !placeholder.dataset.sectionId) return;
    const sectionId = placeholder.dataset.sectionId;
    if (loadingIds.has(sectionId)) return;

    loadingIds.add(sectionId);
    try {
      const currentPath = window.location.pathname;
      const res = await fetch(`${currentPath}?sections=${sectionId}&lazy=1`);
      const data = await res.json();
      if (!data[sectionId]) return;

      const temp = document.createElement('div');
      temp.innerHTML = data[sectionId];
      if (temp.firstElementChild) {
        placeholder.replaceWith(temp.firstElementChild);
      }
    } catch (err) {
      console.error('[LazySection] Failed:', sectionId, err);
    } finally {
      loadingIds.delete(sectionId);
    }
  }

  // Eagerly load the first deferred section to avoid a scroll dead-zone
  // between fully rendered content and the first placeholder.
  const firstPlaceholder = placeholders[0];
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => loadSection(firstPlaceholder), { timeout: 1500 });
  } else {
    window.setTimeout(() => loadSection(firstPlaceholder), 300);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        loadSection(entry.target);
      });
    },
    { rootMargin: '900px' }
  );

  placeholders.forEach((el) => observer.observe(el));
})();
